<div class="video-modal">
  <mat-card>
    <div class="modal-header">
      <h2 mat-dialog-title>Tutoriel versement</h2>
      <button mat-icon-button (click)="closeModal()" class="close-button" aria-label="Fermer">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-card>
  <div mat-dialog-content class="video-container">
    <video
      #videoPlayer
      controls
      playsinline
      muted
      width="100%"
      (loadedmetadata)="autoPlayVideo()">
      <source [src]="videoUrl" type="video/mp4">
      Votre navigateur ne supporte pas la lecture de vidéos.
    </video>
  </div>
</div>
